import React, { memo } from 'react';
import { Play, Pause, SkipBack, SkipForward, Volume2, Scissors, Layers } from 'lucide-react';

const VideoContent = memo(({ activity }) => {
  const isPlaying = activity?.action === 'play';
  const isTrimming = activity?.action === 'trim';
  const isScrolling = activity?.action === 'scroll';
  const isClicking = activity?.action === 'click';

  return (
    <div className="finalcut-content">
      {/* Toolbar */}
      <div className="finalcut-toolbar">
        <div className="toolbar-section">
          <button className="fcp-btn">Import</button>
          <button className="fcp-btn">Export</button>
        </div>
        <div className="toolbar-section">
          <span className="project-name">Summer Vlog 2024</span>
        </div>
        <div className="toolbar-section">
          {isClicking && <span className="toolbar-action">✨ Adding Transition...</span>}
        </div>
      </div>

      <div className="finalcut-layout">
        {/* Media Browser */}
        <div className={`media-browser ${isScrolling ? 'scrolling' : ''}`}>
          <div className="browser-header">Media</div>
          <div className="media-clips">
            <div className="media-clip">
              <div className="clip-thumb">🎬</div>
              <span className="clip-name">intro.mp4</span>
            </div>
            <div className="media-clip">
              <div className="clip-thumb">🎥</div>
              <span className="clip-name">beach.mp4</span>
            </div>
            <div className="media-clip">
              <div className="clip-thumb">🎞️</div>
              <span className="clip-name">sunset.mp4</span>
            </div>
            <div className="media-clip">
              <div className="clip-thumb">🌅</div>
              <span className="clip-name">drone.mp4</span>
            </div>
            <div className="media-clip">
              <div className="clip-thumb">🎵</div>
              <span className="clip-name">music.mp3</span>
            </div>
          </div>
        </div>

        {/* Viewer */}
        <div className="viewer-section">
          <div className="viewer">
            <div className="viewer-screen">
              <div className="video-preview">
                <div className="preview-gradient"></div>
                <div className="play-overlay">
                  {isPlaying ? <Pause size={20} /> : <Play size={20} />}
                </div>
              </div>
            </div>
            <div className="viewer-controls">
              <button className="viewer-btn"><SkipBack size={8} /></button>
              <button className={`viewer-btn play ${isPlaying ? 'active' : ''}`}>
                {isPlaying ? <Pause size={10} /> : <Play size={10} />}
              </button>
              <button className="viewer-btn"><SkipForward size={8} /></button>
              <div className="timecode">00:01:23:15</div>
            </div>
          </div>
        </div>
      </div>

      {/* Timeline */}
      <div className="timeline-section">
        <div className="timeline-header">
          <span className="timeline-title">Timeline</span>
          <div className="timeline-tools">
            <button className="timeline-btn"><Scissors size={8} /></button>
            <button className="timeline-btn"><Layers size={8} /></button>
          </div>
        </div>
        <div className="timeline">
          <div className="timeline-ruler">
            <span className="timecode-marker">00:00</span>
            <span className="timecode-marker">00:30</span>
            <span className="timecode-marker">01:00</span>
            <span className="timecode-marker">01:30</span>
          </div>
          <div className="timeline-tracks">
            <div className="track">
              <div className="track-label">V1</div>
              <div className="track-content">
                <div className={`clip video ${isTrimming ? 'trimming' : ''}`} style={{ width: '60px', left: '0px' }}>
                  <span className="clip-text">intro.mp4</span>
                </div>
                <div className="clip video" style={{ width: '80px', left: '65px' }}>
                  <span className="clip-text">beach.mp4</span>
                </div>
                <div className="clip video" style={{ width: '50px', left: '150px' }}>
                  <span className="clip-text">sunset.mp4</span>
                </div>
              </div>
            </div>
            <div className="track">
              <div className="track-label">A1</div>
              <div className="track-content">
                <div className="clip audio" style={{ width: '120px', left: '0px' }}>
                  <div className="waveform"></div>
                </div>
                <div className="clip audio" style={{ width: '80px', left: '125px' }}>
                  <div className="waveform"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="playhead" style={{ left: '45px' }}></div>
        </div>
      </div>
    </div>
  );
});

VideoContent.displayName = 'VideoContent';

export default VideoContent;
